import { render, staticRenderFns } from "./homeBarEchart.vue?vue&type=template&id=5bfb2caa&scoped=true&"
import script from "./homeBarEchart.vue?vue&type=script&lang=js&"
export * from "./homeBarEchart.vue?vue&type=script&lang=js&"
import style0 from "./homeBarEchart.vue?vue&type=style&index=0&id=5bfb2caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfb2caa",
  null
  
)

export default component.exports